// Func = limiting Scope for this file
var lastScrollTop = 0

if ('NodeList' in window && !NodeList.prototype.forEach) {
	console.info('polyfill for IE11')
	NodeList.prototype.forEach = function (callback, thisArg) {
		thisArg = thisArg || window
		for (let i = 0; i < this.length; i++) {
			callback.call(thisArg, this[i], i, this)
		}
	}
}

;(function () {
	let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item')
	itemsMenu.forEach((itemMenu) => {
		if (itemMenu.querySelector('.submenu')) {
			itemMenu.addEventListener('mouseenter', () => {
				itemMenu.classList.add('hover')
				itemMenu.querySelector('.submenu').classList.add('show')
			})
			itemMenu.addEventListener('mouseleave', () => {
				itemMenu.classList.remove('hover')
				itemMenu.querySelector('.submenu').classList.remove('show')
			})
		}
	})

	window.onload = function () {
		scrollW()
		window.addEventListener('scroll', function () {
			scrollW()
		})
	}

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || []
	paragraph.forEach(
		(e) => e.innerHTML.trim() === '' && e.parentNode.removeChild(e),
	)

	// burger menu
	const burgerCtas = document.querySelectorAll('[data-ctaburger]')
	if (burgerCtas) {
		const burgerMenu = document.querySelector('[data-menuburger]')
		burgerCtas.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				burgerMenu.classList.toggle('open')
				document.body.classList.toggle('no-scroll')
			})
		})
	}

	//animation scroll
	const ctas_scroll = document.querySelectorAll('[data-scroll],.scroll');
	if (ctas_scroll) {
		ctas_scroll.forEach((cta) => {
			cta.addEventListener('click', (e) => {
				e.preventDefault()
				const section_to_scroll = new URL(e.target.href)
				animateTo(section_to_scroll.hash)
			})
		})
	}

	//home animation scroll
	if (location.pathname === '/') {
		const links_scroll = document.querySelectorAll('#privary-navigation a:not(.logo)')
		links_scroll.forEach((link) => {
			link.addEventListener('click', (e) => {
				e.preventDefault()
				let section_to_scroll = new URL(e.target.href)
				animateTo(section_to_scroll.hash)
				if (window.innerWidth < 768) {
					document.querySelector('[data-menuburger]').classList.remove('open')
					document.body.classList.remove('no-scroll')
				}
			})
		})
	}
	//scroll animation quad food
	
    const elements = document.querySelectorAll('.food-quad__moon');
		if (elements) {
			
		
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                window.addEventListener('scroll', handleScroll);
            } else {
                window.removeEventListener('scroll', handleScroll);
            }
        });
    }, {
				rootMargin: "100px",
        threshold: 0.5
    });

	// loading animation
	let svgContainer = document.getElementById('preloader-js');
	if(svgContainer){
		setTimeout(function(){
			document.getElementById('preloader-js').classList.add('close');
		}, 3500);
		var animItem = lottie.loadAnimation({
			wrapper: svgContainer,
			animType: 'svg',
			loop: false,
			path: `loader-animation2.json`,
		});
	}


    elements.forEach(element => {
        observer.observe(element);
    });

    function handleScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			const maxRotation = 70; 
			const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
			elements.forEach(element => {
					const rotationAngle = (scrollTop / maxScroll ) * (maxRotation * 2.7) - maxRotation;
					element.style.transform = `rotate(${rotationAngle - 40}deg)`;
			});
	}
}


		const targetSection = document.querySelector('.intro-content-home');
		if (targetSection) {
			
		
		const observerOptions = {
				root: null, // Usa el viewport como contenedor
				rootMargin: '0px',
				threshold: 0.5 // La sección debe estar al menos al 50% visible
		};

		const observerCallback = (entries, observer) => {
				entries.forEach(entry => {
						if (entry.isIntersecting) {
								entry.target.classList.add('observed');
						} 
				});
		};

		const observer = new IntersectionObserver(observerCallback, observerOptions);

		if (targetSection) {
				observer.observe(targetSection);
		}
	}
})()

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!document.getElementById('header').classList.contains('down')) {
				document.getElementById('header').classList.add('down')
				document.getElementById('header').classList.remove('up')
			}
		} else {
			// upscroll code
			if (!document.getElementById('header').classList.contains('up')) {
				document.getElementById('header').classList.add('up')
				document.getElementById('header').classList.remove('down')
			}
		}
	} else {
		if (
			document.getElementById('header').classList.contains('up') ||
			document.getElementById('header').classList.contains('down')
		) {
			document.getElementById('header').classList.remove('up')
			document.getElementById('header').classList.remove('down')
		}
	}
	lastScrollTop = st <= 0 ? 0 : st // For Mobile or negative scrolling
}

//animation of scroll vanilla JS
function animateTo(target){
	var gotoTarget = location.pathname =='/' ? offset(document.querySelector(target)).top - 40 :  offset(document.querySelector(target)).top - 110;
	var from     = window.pageYOffset
	var to       = gotoTarget
	var duration = 1300; 
	var start = new Date().getTime()

	//time interval
	var timer = setInterval(function() {
		var time = new Date().getTime() - start

		if(from <= to ){
			var yH = easeInOutQuart(time, from, to - from, duration)
		} else {
			
			var yH = easeInOutQuart(time, from, -(from - to), duration)
		}
		window.scrollTo(0, yH)
		if (time >= duration) clearInterval(timer)

	}, 1000 / 60);

	window.scrollTo(0, from)

}

//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return c / 2 * t * t * t * t + b;
	return -c / 2 * ((t -= 2) * t * t * t - 2) + b;
}

//window offset
function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}
